export interface OpenClawOnboardingOptions {
  serverUrl: string;
  apiKey: string;
}

/**
 * Produces the canonical, additive OpenClaw setup guidance for a Borgee account.
 * Operators must inspect their configuration and merge each addition rather than
 * replacing existing accounts, bindings, tool policy, or allow-lists.
 */
export function buildOpenClawOnboardingPlan({ serverUrl, apiKey }: OpenClawOnboardingOptions): string {
  return `To accept this invitation, add Borgee alongside your existing OpenClaw channels.

# Install the Borgee plugin (skip if already installed)
openclaw plugins install @borgee/openclaw-plugin

# Add a Borgee account
# Pick a simple account slug (letters, numbers, - or _, for example "borgee").
# Preserve any existing Borgee accounts and channel policy.
openclaw config set channels.borgee.accounts.YOUR_ACCOUNT_SLUG.baseUrl '"${serverUrl}"'
openclaw config set channels.borgee.accounts.YOUR_ACCOUNT_SLUG.apiKey '"${apiKey}"'

# Enable the plugin and token-usage telemetry (skip if already enabled)
# This lets Borgee read final-turn usage for telemetry. Borgee does not persist message content.
openclaw config set plugins.entries.borgee.enabled true
openclaw config set plugins.entries.borgee.hooks.allowConversationAccess true

# Ensure Borgee tool access while preserving your existing tool profile or allow-list
# Inspect your current tools configuration, then merge message and borgee_task into its additional allow-list.
# Example additive configuration: {"tools":{"alsoAllow":["message","borgee_task"]}}

# Add a Borgee binding safely
# Inspect your existing bindings and merge this entry; do not replace the bindings array.
# Replace YOUR_AGENT_ID and YOUR_ACCOUNT_SLUG:
# {"agentId":"YOUR_AGENT_ID","match":{"channel":"borgee","accountId":"YOUR_ACCOUNT_SLUG"}}

# Restart to connect
openclaw gateway restart`;
}
